type HeadingProps = {
	title?: string;
	description?: string;
	type?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
};

export default function Heading({ title, description, type = 'h2' }: HeadingProps) {
	const HeadingTag = type;

	return (
		<div className="feature__heading">
			<hgroup className="feature__heading">
				<HeadingTag className="feature__heading--headline">{title}</HeadingTag>
				<p className="feature__heading--sub-headline text-subline">{description}</p>
			</hgroup>
		</div>
	);
}
